export default "__VITE_ASSET__ne5iiYfa__"